'use client';

import Link from 'next/link';

import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { FieldLabels } from '@shared/types/enums/fieldLabels.enum';
import { Button } from '@shared/ui/Button';
import { Checkbox } from '@shared/ui/Checkbox';
import { Input } from '@shared/ui/Input';
import { HStack } from '@shared/ui/Stack';

import { changeAgree, changeName, changePhone, sendData } from '../../model/slice/feedbackSlice';
import cls from './Form.module.scss';

export const Form = () => {
  const dispatch = useAppDispatch();
  const name = useAppSelector((state) => state.feedback.name);
  const phone = useAppSelector((state) => state.feedback.phone);
  const agree = useAppSelector((state) => state.feedback.agree);
  const errors = useAppSelector((state) => state.feedback.errors);
  const loading = useAppSelector((state) => state.feedback.loading);

  const changeNameHandler = (value: string) => {
    dispatch(changeName(value));
  };

  const changePhoneHandler = (value: string) => {
    dispatch(changePhone(value));
  };

  const changeAgreeHandler = (value: boolean) => {
    dispatch(changeAgree(value));
  };

  const send = () => {
    dispatch(sendData());
  };

  return (
    <div
      role={'form'}
      aria-label={'Форма обратной связи'}
      className={cls.wrap}
    >
      <HStack
        className={cls.row}
        gap={'8'}
      >
        <Input
          className={cls.field}
          testId={'feedback-form-name'}
          label={FieldLabels.FIRST_NAME}
          onChange={changeNameHandler}
          value={name}
          isError={errors.name}
        />
        <Input
          phoneMask
          className={cls.field}
          testId="feedback-form-phone"
          label={FieldLabels.PHONE_NUMBER}
          onChange={changePhoneHandler}
          value={phone}
          isError={errors.phone}
        />
        <Button
          aria-label={'Отправить заявку'}
          testId={'feedback-form-button'}
          onClick={send}
          loadingButton
          isLoading={loading}
          className={cls.button}
          size={'l'}
        >
          Отправить
        </Button>
      </HStack>
      <div className={cls.policy}>
        <Checkbox
          testId="feedback-form-policy"
          aria-label={'Подтвердите согласие на обработку персональных данных'}
          variant={'secondary'}
          isError={errors.agree}
          value={agree}
          onChange={changeAgreeHandler}
        />
        <div className={cls.text}>
          Я принимаю согласие на{' '}
          <Link
            aria-label={'Перейти на страницу обработки персональных данных'}
            className={cls.link}
            target={'_blank'}
            href={ROUTES.CONSENT_PERSONAL_DATA}
          >
            обработку персональных данных
          </Link>
        </div>
      </div>
    </div>
  );
};
